import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const getLastRefreshDate = async (token: string | null) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/GetLastRefreshDate`, {
            headers: {
                'Authorization': `Bearer ${token}` 
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching last refresh date:', error);
        throw error;
    }
};
